<template>
    <Card>
        <div class="card-body">
            <Button size="sm" color="teal" @click="$refs.AddRecommendationProductModal.show()">
                {{ $t('buttons.add') }}
            </Button>
        </div>
        <Table :columns="columns" :url="url" :handle="tableHandle" :has-checkbox="true" @update:selected-values="selectedValues = $event" v-model:orders="orders">
            <template #actionDropdownItems>
                <DropdownItem @click="removeProductRecommendations">{{ $t('buttons.delete') }}</DropdownItem>
            </template>
            <template #td-image="{row}">
                <img :src="row.main_image_url" class="table-image">
            </template>
            <template #td-category="{row}">
                <AppNullableCell>
                    <template #default v-if="row.category">
                        {{ row.category.name }}
                    </template>
                </AppNullableCell>
            </template>
            <template #td-sku="{row}">
                <AppNullableCell>
                    <template #default v-if="row.sku">
                        {{ row.sku }}
                    </template>
                </AppNullableCell>
            </template>
            <template #td-balance="{row}">
                {{ Amount.factory(row.balance_with_reserve).toMeasurementString(product.measurement) }}
            </template>
            <template #td-reserve="{row}">
                {{ Amount.factory(row.reserve).toMeasurementString(product.measurement) }}
            </template>
            <template #td-waiting="{row}">
                {{ Amount.factory(row.waiting).toMeasurementString(product.measurement) }}
            </template>
            <template #td-available="{row}">
                {{ Amount.factory(row.balance).toMeasurementString(product.measurement) }}
            </template>
        </Table>
    </Card>
    <AddRecommendationProductModal
        ref="AddRecommendationProductModal"
        :product-recommendations="product.product_recommendations ?? []"
        @update:productRecommendations="updateProductRecommendations"
    />
</template>
<script>
import Card from "../../../../../components/new/CardComponent.vue";
import Table from "../../../../../components/new/table/FetchTable.vue";
import { createTableHandle } from "../../../../../components/new/table/tableHandle";
import AddRecommendationProductModal from "../modals/AddRecommendationProductModal.vue";
import DropdownItem from "../../../../components/btnDropdown/DropdownItem.vue";
import Amount from "../../../../../services/Amount";
import Button from "../../../../../components/new/button/AppButton.vue";
import AppNullableCell from "../../../../components/tables/AppNullableCell.vue";

import { httpClient } from "../../../../../services/HttpClient";

export default {
    name: 'InternalProductRecommendationsPage',
    components: {
        Card,
        Table,
        AddRecommendationProductModal,
        DropdownItem,
        Button,
        AppNullableCell
    },
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            Amount,
            url: `/catalog/product-items`,
            columns: [
                {key: "id", name: this.$t('table.titles.id'), width: "80px", type: "string", order: true},
                {key: "image", name: this.$t('table.titles.image'), width: "200px", type: "image", order: false},
                {key: "category", name: this.$t('table.titles.product_type'), width: "auto", type: "string", order: false},
                {key: "sku", name: this.$t('table.titles.sku'), width: "200px", type: "string", order: true},
                {key: "balance", name: this.$t('table.titles.balance'), width: "200px", type: "string", order: true},
                {key: "reserve", name: this.$t('table.titles.reserve'), width: "200px", type: "string", order: true},
                {key: "available", name: this.$t('table.titles.available'), width: "200px", type: "string", order: false},
                {key: "waiting", name: this.$t('table.titles.waiting'), width: "200px", type: "string", order: true},
            ],
            selectedValues: [],
            orders: []
        }
    },
    methods: {
        updateProductRecommendations(productRecommendationUuid) {
            this.product.product_recommendations = [...(this.product.product_recommendations ?? []), productRecommendationUuid]
            this.tableHandle.fetchRows({
                extra: 1,
                uuids: [...this.product.product_recommendations]
            })

            this.selectedValues = []
        },
        removeProductRecommendations() {
            this.product.product_recommendations = this.product.product_recommendations.filter(uuid => !this.selectedValues.includes(uuid))

            httpClient.patch(`/catalog/product-items/${this.product.uuid}`, {
                product_recommendations: this.product.product_recommendations
            }).then(() => {
                    if (this.product.product_recommendations.length > 0) {
                        this.tableHandle.fetchRows({
                            extra: 1,
                            uuids: this.product.product_recommendations
                        })
                    } else {
                        this.tableHandle.rows = []
                    }

                    this.selectedValues = []
                }
            )
        }
    },
    mounted() {
        if (this.product.product_recommendations) {
            this.tableHandle.fetchRows({
                uuids: this.product.product_recommendations,
                extra: 1
            });
        }
    }
}
</script>
<style>
.table-image {
    max-width: 50px;
    max-height: 50px;
}
</style>